import React from 'react';
import { Box, Typography } from 'vindi-ds-components';
import templatePricing from '@pages/product/templates/template_pricing';

function PricingType({ schemaType }) {
  return (
    <Box>
      <Typography variant='body2' component='p'>
        Cálculo de preço
      </Typography>
      <Typography variant='body1' component='p'>
        {templatePricing[schemaType].title}
      </Typography>
    </Box>
  );
}

export default PricingType;
